import React, { useEffect, useState } from 'react';

export type NavbarLink = {
  label: string;
  href: string;
  primary?: boolean;
};

export default function Navbar(props: { breadcrumb?: NavbarLink; links: NavbarLink[]; transparentAtTop?: boolean }) {
  const atTop = useAtTop();

  return (
    <nav className={`navbar ${props.transparentAtTop ? 'transparent-at-top' : ''} ${atTop ? 'at-top' : ''}`}>
      <div className="content-wrapper">
        <div className="content">
          <Logo />
          <Breadcrumb link={props.breadcrumb} />
          <ul className="links">
            {props.links.map(link => (
              <li className={link.primary ? 'primary' : ''}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export function Logo() {
  const href = 'https://computing-den.com';
  return (
    <a href={href} className="logo" onClick={e => scrollToTopIfOnSamePage(e, href)}>
      Computing Den
    </a>
  );
}

export function Breadcrumb(props: { link?: NavbarLink }) {
  const { link } = props;
  if (!link) return null;

  return (
    <>
      <span className="logo-breadcrumb-separator">|</span>
      <a href={link.href} className="breadcrumb" onClick={e => scrollToTopIfOnSamePage(e, link.href)}>
        {link.label}
      </a>
    </>
  );
}

function useAtTop() {
  const [atTop, setAtTop] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY > 400) {
        setAtTop(false);
      } else if (window.scrollY < 300) {
        setAtTop(true);
      }
    };
    scrollHandler();
    document.addEventListener('scroll', scrollHandler);
    return () => document.removeEventListener('scroll', scrollHandler);
  }, []);

  return atTop;
}

function scrollToTopIfOnSamePage(e: React.MouseEvent, href: string) {
  const currentUrl = new URL(window.location.toString());
  currentUrl.hash = '';

  const targetUrl = new URL(href, window.location.toString());

  if (currentUrl.toString() === targetUrl.toString()) {
    e.preventDefault();
    e.stopPropagation();
    window.location.hash = '';
    window.scrollTo(0, 0);
  }
}
